export enum AssignmentStatus {
  QUEUED = "QUEUED",
  COMPLETED = "COMPLETED",
  SKIPPED = "SKIPPED",
}
